import { createFeatureSelector, createSelector } from '@ngrx/store'
import { initialConfigFeatureKey, InitialConfigState } from '../reducers/initial-config.reducer'
import { LoginMethodEnumArray } from '../../../../login/shared/login-method-enum'

export const selectInitialConfigState = createFeatureSelector<InitialConfigState>(initialConfigFeatureKey)

export const selectUseTestRecaptcha = createSelector(selectInitialConfigState, (state) => state.config.useTestRecaptcha)

export const selectLoaded = createSelector(selectInitialConfigState, (state) => state.loaded)

export const selectConfig = createSelector(selectInitialConfigState, (state) => state.config)

export const selectExternalLogins = createSelector(selectConfig, (state) =>
  state.externalAuthProviders.length > 0 ? state.externalAuthProviders : null,
)

export const selectInternalAuthMethods = createSelector(selectConfig, (state) => state.internalAuthMethods)

export const selectHasEmailPasswordAuth = createSelector(selectInternalAuthMethods, (methods) =>
  methods.some((method) => method === LoginMethodEnumArray[0]),
)

export const selectHasPhonePasswordAuth = createSelector(selectInternalAuthMethods, (methods) =>
  methods.some((method) => method === LoginMethodEnumArray[1]),
)

export const selectExternalClientDetails = createSelector(selectConfig, (state) => state.externalClientDetails)
